import { render, staticRenderFns } from "./OAJVOMTA.vue?vue&type=template&id=69029734&scoped=true"
import script from "./OAJVOMTA.vue?vue&type=script&lang=js"
export * from "./OAJVOMTA.vue?vue&type=script&lang=js"
import style0 from "./OAJVOMTA.vue?vue&type=style&index=0&id=69029734&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69029734",
  null
  
)

export default component.exports